import DataApi from './DataApi';

class CurrencyMasterApi extends DataApi {
  constructor() {
    super('currency-master');
  }

  getByCode(code) {
    return this.fetchById(encodeURIComponent(code));
  }

  updateByCode(data, code) {
    return this.update(data, encodeURIComponent(code));
  }
}

export default CurrencyMasterApi;
